export default "__VITE_ASSET__DaiuM6u1__"